//import * as d3 from "d3";
import store from "../store";
import axios from "axios";

export default {
  getData: async function() {
    axios
      .get(store.state.host + "api/v1/publicReports", {
        params: {}
      })
      .then(response => {
        response.data.result.forEach(el => {
          if (el.victimData.disappearanceDate) {
            el.year = el.victimData.disappearanceDate.year;
          }
          if (el.narrative.lastSeenLocation) {
            el.lat = parseFloat(el.narrative.lastSeenLocation.lat);
            el.lng = parseFloat(el.narrative.lastSeenLocation.lng);
          }
        });
        store.commit("setReports", response.data.result);
        this.filterData();
      })
      .catch(error => {
        console.log(error);
      });
  },
  filterData() {
    let filteredReports = store.state.reports;

    if (
      store.state.filters.period &&
      (store.state.filters.period[0] !== store.state.min ||
        store.state.filters.period[1] !== store.state.max)
    ) {
      filteredReports = filteredReports.filter(report => {
        return (
          report.year >= store.state.filters.period[0] &&
          report.year <= store.state.filters.period[1]
        );
      });
    }
    if (
      store.state.filters.firstAge &&
      store.state.filters.firstAge !== "" &&
      (store.state.filters.secondAge && store.state.filters.secondAge !== "")
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.victimData.disappearanceAge) {
          return (
            report.victimData.disappearanceAge >= store.state.filters.firstAge &&
            report.victimData.disappearanceAge <= store.state.filters.secondAge
          );
        }
      });
    } else if (
      store.state.filters.firstAge &&
      store.state.filters.firstAge !== ""
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.victimData.disappearanceAge) {
          return (
            report.victimData.disappearanceAge >= store.state.filters.firstAge
          );
        }
      });
    } else if (
      store.state.filters.secondAge &&
      store.state.filters.secondAge !== ""
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.victimData.disappearanceAge) {
          return (
            report.victimData.disappearanceAge <= store.state.filters.secondAge
          );
        }
      });
    }

    if (store.state.filters.sex && store.state.filters.sex !== "Todos") {
      filteredReports = filteredReports.filter(report => {
        if (report.victimData.sex) {
          return report.victimData.sex === store.state.filters.sex;
        }
      });
    }

    if (
      store.state.filters.victimStatus &&
      store.state.filters.victimStatus !== "Todos"
    ) {
      filteredReports = filteredReports.filter(report => {
        if (report.narrative.tracing.victimStatus) {
          return (
            report.narrative.tracing.victimStatus ===
            store.state.filters.victimStatus
          );
        }
      });
    }

    if (store.state.filters.state && store.state.filters.state !== "Todos") {
      filteredReports = filteredReports.filter(report => {
        if (report.victimData.disappearanceState) {
          return (
            report.victimData.disappearanceState === store.state.filters.state
          );
        }
      });
    }

    store.commit("setFilteredReports", filteredReports);

    const filteredStates = [
      ...new Set([
        ...filteredReports.map(el => {
          return el.victimData.disappearanceState;
        })
      ])
    ].sort();

    store.commit("setFilteredStates", filteredStates);
    store.commit("setSelection", undefined);
  }
};
